import { paths } from './paths';

/**
 * Per-route overrides for the MainLayout. Each flag opts the route OUT of a
 * default layout behavior. To customize layout behavior for a new route, add
 * an entry under `ROUTE_LAYOUT_OVERRIDES` below — no changes needed in
 * `main-layout.tsx`.
 */
export interface RouteLayoutOptions {
  /**
   * When true, BhanzuBuddy is hidden on this route.
   * @default false
   */
  hideBhanzuBuddy?: boolean;
  /**
   * When true, the desktop header is rendered with `static` positioning
   * instead of `lg:sticky`, so it scrolls away with the page.
   * @default false
   */
  nonStickyHeader?: boolean;
}

const DEFAULT_LAYOUT_OPTIONS: Required<RouteLayoutOptions> = {
  hideBhanzuBuddy: false,
  nonStickyHeader: false,
};

const ROUTE_LAYOUT_OVERRIDES: Record<string, RouteLayoutOptions> = {
  [paths.app.onboarding.path]: {
    hideBhanzuBuddy: true,
  },
  [paths.app.referralInd.path]: {
    hideBhanzuBuddy: true,
    nonStickyHeader: true,
  },
};

export const getRouteLayoutOptions = (
  pathname: string
): Required<RouteLayoutOptions> => ({
  ...DEFAULT_LAYOUT_OPTIONS,
  ...ROUTE_LAYOUT_OVERRIDES[pathname],
});
